<app-header [menuOpen]="menuOpen()" (menuToggle)="toggleMenu()" />
<app-mobile-menu [open]="menuOpen()" (closed)="closeMenu()" />

<main>
  <app-hero />
  <app-about />
  <app-experience />
  <app-projects />
  <app-skills />
  <app-education />
  <app-contact />
</main>

<app-footer />
